/* src/app/ai-sourcing/project-details/project-details.component.scss */
.tabActive {
  padding: 8px 25px;
  border-bottom: 1px solid #2E93A1;
  color: #2E93A1;
  font-weight: 600;
}
.tabBtn {
  padding: 8px 25px;
  color: #2E93A1;
  font-weight: 600;
}
.ai-source-chips {
  background: #E4F1F3;
  border-radius: 16px;
  padding: 3px 8px;
  font-size: 14px;
  display: flex;
  align-items: center;
  color: #484b59;
  margin-right: 8px;
  margin-bottom: 8px;
}
.ai-source-chips span i {
  margin-right: 4px;
}
.ai-source-chips .companylogo {
  width: 17px;
  height: 17px;
  border-radius: 17px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #D9D9D9;
  margin-right: 4px;
}
.btn-trms-small.bg-gray {
  background-color: #969696 !important;
  color: #fff !important;
  border: 0px !important;
}
/*# sourceMappingURL=project-details.component-UZHQG42K.css.map */
